 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		1: 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "" + ({"0":"common","12":"polyfills-core-js","13":"polyfills-css-shim","14":"polyfills-dom","16":"stencil-polyfills-css-shim","17":"stencil-polyfills-dom"}[chunkId]||chunkId) + "-es2015." + {"0":"83e4d1284224bf613be6","2":"0e6881912747c5d08aa8","3":"d7424fece7f9be92bab2","4":"9b793b45cd344542ff7b","5":"ec09f5dc350a7aaab6cb","6":"3f0733bd406eaca9ff85","7":"29f79970dff68a33933a","8":"c1f117c35671e07d95fe","9":"376ebcef826cfe69ce71","12":"659269812cc37e5e580d","13":"3087207a3f1eabd47120","14":"4a206b8ebc4e2b7aab81","16":"08f047c87f5de8edb46d","17":"6076198b7012764080b0","19":"452eebeb117c87bdcd02","20":"a80f8386ef9b1c5d534b","21":"7a54d18a17e046380264","22":"4061eaacb092286acfd5","23":"676c1870509c83c55cf0","24":"5885329e00893b1088dc","25":"5dec5f44dc8fcc536194","26":"3c7e864e501d951e9220","27":"121eab287110c929e00c","28":"3aaf6a90709e755916b6","29":"9647bf820103aa31b007","30":"ccd70a991d4ef880a80a","31":"dbd868859568a47e141a","32":"35c46f4609fc5a8b39be","33":"ae4b5513068a35c95703","34":"26ccc57ad80b6007611a","35":"aea9d78d5741a3f7b492","36":"7e16a643aca6df8c1bdb","37":"7ddb6f60607c86e92825","38":"7ea83dc2e59c9b649db7","39":"8b91af4c17648b583281","40":"6cdc0f62b7e6ca59e4b3","41":"b2d3d4a0e4d7b83f8e2c","42":"fe75d0e7b7dcc7658d38","43":"6052ad9c013ff4d3b1b5","44":"f6113ba4e386e30d0d52","45":"fe1194bebcafd6136492","46":"8851f954d6c9f993fb4d","47":"905c4b033b0fec4bf7e9","48":"215ab8e029b2abe93084","49":"52dc27529aff218767d7","50":"8a6465664b6e8da0653c","51":"24a2951ce85427b176b9","52":"add345bbe374fd3b7a23","53":"7151bc3f32ac528f99e8","54":"6b1f3ee4bf8f2a4349e1","55":"be8cc75bcd3dc6aae1d1","56":"f718a0d09d8a529c9812","57":"f294a7290ff3649243e6","58":"f9f2a7450da8b8ef3b11","59":"32bab757bd4d6e72e059","60":"f071fa893a7912d10426","61":"76354adaebc529e28d5c","62":"5076d48d0ef01c7c425b","63":"c4cc37ac2b36a3bfde03","64":"e91353264219255d79fe","65":"4483db8e2af6bfd92bb7","66":"2852e740077fe7422a70","67":"fe850ea227b0f088a360","68":"b99400d849d5ad4f98bf","69":"d0b1f68f042145b4f991","70":"a754e12b6cc1decc14da","71":"04209c1e1782985dbce0","72":"f179547b98969fc1867a","73":"22ad6f24ee95e2be97bd","74":"6cf9e9bf9ae934761ece","75":"dd0e19b71a5331094d3b","76":"9d968e1b57245f0c471f","77":"afec551fd97645e73ca0","78":"df8e8a94f0bb44f5cbf8","79":"efa6ef110b88f7537c29","80":"fe217406a0a0277be0c9","81":"2c610da2e9378f2db893","82":"ab7d4fe604d819550493","83":"aa5c01955d2060c900e1","84":"1534000fa167f7c58fde","85":"28c745a8f73119f7998c","86":"fb45359255927b84b89e","87":"61cd276b57d0daa44fd8","88":"0fd14fe24a617535c850","89":"26bbfe5dd41b2f86d2df","90":"cea7910b1b6e81311c79","91":"5b89561c42c95a617c1b","92":"57600583f3790a016bff","93":"81fdda9168acc74155c6","94":"3971be7fb8f68e223375","95":"fc9e03054725f81e3ffc","96":"9062d9d9f5260cd28660","97":"193f5c13ff79eb455f8d","98":"0809468ff32624294ec7","99":"7877621e7092670ea1dd","100":"cafe84392e72bca307ca","101":"4b0159c03beab77cbc8c","102":"165a0c0fc6086a3c05ba","103":"60755b7c4a87da66af9e","104":"d3c034c1067bb60c7dd0","105":"e3716e986eed817e4709","106":"91d20e35157aef637070"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// run deferred modules from other chunks
 	checkDeferredModules();
